/**
 * @generated SignedSource<<682672c78fbeda30bf8e176aa287a0ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type MATOrganizationPlanEnum = "enterprise" | "free" | "team" | "%future added value";
export type MATOrganizationPremiumTypeEnum = "premium_non_refundable" | "premium_refundable" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type MATInvoiceConnectionDataTable_matInvoiceConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly amount: number;
      readonly endDate: any;
      readonly id: string;
      readonly isMonthlyPaid: boolean;
      readonly maxStudentCount: number;
      readonly plan: MATOrganizationPlanEnum;
      readonly premiumType: MATOrganizationPremiumTypeEnum;
      readonly scholarshipAmount: number | null;
      readonly startDate: any;
      readonly title: string;
      readonly " $fragmentSpreads": FragmentRefs<"MATInvoiceStateLabel_matInvoice">;
    };
  }>;
  readonly " $fragmentType": "MATInvoiceConnectionDataTable_matInvoiceConnection";
};
export type MATInvoiceConnectionDataTable_matInvoiceConnection$key = {
  readonly " $data"?: MATInvoiceConnectionDataTable_matInvoiceConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"MATInvoiceConnectionDataTable_matInvoiceConnection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MATInvoiceConnectionDataTable_matInvoiceConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MATInvoiceEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MATInvoice",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "premiumType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "plan",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "scholarshipAmount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maxStudentCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "amount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isMonthlyPaid",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "MATInvoiceStateLabel_matInvoice"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MATInvoiceConnection",
  "abstractKey": null
};

(node as any).hash = "a0148b424548cb33eaf0b99cd1d79b05";

export default node;
